import {
  SET_MODIFIER_SETTINGS_DATA_LOADING,
  SET_MODIFIER_SETTINGS_DATA,
} from '../actions/types';

const initialState = {
  isLoading: false,
  modifierSettingsData: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_MODIFIER_SETTINGS_DATA_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case SET_MODIFIER_SETTINGS_DATA:
      return {
        ...state,
        modifierSettingsData: Array.isArray(payload) ? [...payload] : [],
        isLoading: false,
      };
    default:
      return state;
  }
}
